import { render, staticRenderFns } from "./ItemDayRecommended.vue?vue&type=template&id=05174087&scoped=true&"
import script from "./ItemDayRecommended.vue?vue&type=script&lang=js&"
export * from "./ItemDayRecommended.vue?vue&type=script&lang=js&"
import style0 from "./ItemDayRecommended.vue?vue&type=style&index=0&id=05174087&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05174087",
  null
  
)

export default component.exports